import { Text, VStack } from '@chakra-ui/react'
import { PopUpMessageContext, ScreenContext } from '@hb/react'
import { PageContainer, useNavigate } from '@hb/react-web'
import { auth } from '@hb/react-web/src/backend/auth'
import { applyActionCode } from 'firebase/auth'
import { useContext, useEffect, useState } from 'react'

interface VerifyEmailViewProps {
  oobCode: string
}

export const VerifyEmailView = ({ oobCode }: VerifyEmailViewProps) => {
  const { contentWidth } = useContext(ScreenContext)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const { showError, showSuccess } = useContext(PopUpMessageContext)

  useEffect(() => {
    const handleVerifyEmail = async () => {
      if (!oobCode) {
        showError('No verification code found')
        navigate('/')
        return
      }
      setLoading(true)
      try {
        await applyActionCode(auth, oobCode)
        showSuccess('Email verified successfully!')
        const currUser = auth.currentUser
        if (currUser) {
          await currUser.reload()
        }
        setTimeout(() => navigate('/'), 2000)
      } catch (error) {
        console.error(error)
        showError('Error verifying email. The link may be invalid or expired.')
        setTimeout(() => navigate('/'), 2000)
      } finally {
        setLoading(false)
      }
    }
    handleVerifyEmail()
  }, [oobCode, showError, showSuccess, navigate])

  return (
    <PageContainer>
      <VStack
        flexDir="column"
        w="100%"
        width={contentWidth}
        bg="gray.50"
        py={4}
        px={6}
        alignItems="flex-start"
        spacing={0}>
        <Text fontFamily="Hero-New" fontSize="xl" fontWeight={500} color="gray.600">
          {loading ? 'Verifying Email' : 'Email Verified'}
        </Text>
        <Text fontSize="lg">
          {loading ? 'Please wait while we verify your email address...' : 'Redirecting...'}
        </Text>
      </VStack>
    </PageContainer>
  )
}
